import React from 'react'

import TotpGuard from '@/app/component/guard/totp'
import Layout from '@/app/component/layout/page'
import { PAGE } from '@/app/definitions'
import { AuthGuard, AuthHeader } from '@/app/module/auth'
import { CampaignManager } from '@/app/module/campaigns'
import Notifications from '@/app/module/notifications'
import { MatchProps } from '@/app/types'

type Props = {
  match: MatchProps
}

const ManagePage: React.FC<Props> = ({ match }) => {
  return (
    <AuthGuard url={match.url} path={match.path}>
      <Layout title="Campaigns - engageSPARK">
        <AuthHeader currentPage={PAGE.CAMPAIGNS.MANAGE} />
        <TotpGuard>
          <CampaignManager itemId={(match.params as any).campaignsId} />
        </TotpGuard>
        <Notifications />
      </Layout>
    </AuthGuard>
  )
}

export default React.memo(ManagePage)
